import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { getAuth, signOut } from 'firebase/auth';
import { AuthService } from 'src/app/shared/services/auth.service';

interface UserDetails {
  uid: string;
}

interface UserProfile {
  companyname: string;
  // displayName: string;
  role?: string;
  photoURL?: string;
  accountdetails?: {
    companyname?: string;
  };
}

interface MenuItem {
  icon: string;
  iconType?: 'mat' | 'emoji';
  label: string;
  route: string;
  active?: boolean;
  badge?: number;
  isHeader?: boolean;
}

@Component({
  selector: 'app-adminuser-layout',
  templateUrl: './adminuser-layout.component.html',
  styleUrls: ['./adminuser-layout.component.scss']
})
export class AdminuserLayoutComponent implements OnInit {
  userdetail!: UserDetails;
  currentuid: string = '';
  userObj: UserProfile = { companyname: '' };
  currentuserrole: string = '';
  currentuserprofile: string = '';
  currentusername: string = '';
  isMobileView = false;
  sidebarOpen = true;
  lang = 'en';
  today = new Date();

  menuItems: MenuItem[] = [
    { icon: 'home', iconType: 'mat', label: 'Homepage', route: '/admin/dashboard' },
    { icon: 'storefront', iconType: 'mat', label: 'Vendor Management', route: '/admin/vendors' },
    { icon: 'folder', iconType: 'mat', label: 'Categories', route: '/admin/categories' },
    { icon: 'layers', iconType: 'mat', label: 'Subcategories', route: '/admin/subcategories' },
    { icon: 'tune', iconType: 'mat', label: 'Field Config', route: '/admin/fieldconfig' },
    { icon: 'card_membership', iconType: 'mat', label: 'Subscriptions', route: '/admin/subscriptions' },
    { icon: 'analytics', iconType: 'mat', label: 'User Analysis', route: '/admin/user-analysis' },
  ];

  constructor(
    private firestoreService: FirestoreService,
    private router: Router,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.lang = localStorage.getItem('lang') || 'en';
    this.translateService.use(this.lang);
    this.getCurrentUser();

    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobileView = result.matches;
      this.sidebarOpen = !result.matches;
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      if (this.isMobileView) {
        this.sidebarOpen = false;
      }
    });
  }

  async getCurrentUser() {
    const res = await this.firestoreService.getUserDetails() as UserDetails;
    if (res?.uid) {
      this.userdetail = res;
      this.currentuid = res.uid;

      const profile = await this.firestoreService.getUserProfile(this.currentuid) as UserProfile;
      if (profile) {
        this.userObj = profile;
        this.currentuserrole = profile.role ?? '';
        this.currentuserprofile = profile.photoURL ?? '';
        this.currentusername = profile.accountdetails?.companyname
          ?? profile.companyname
          ?? 'User';

      }
    }
  }

  ChangeLang(lang: any) {
    const selectedLanguage = lang.target.value;
    this.lang = selectedLanguage;
    localStorage.setItem('lang', selectedLanguage);
    this.translateService.use(selectedLanguage);
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  navigateTo(item: MenuItem) {
    if (item.isHeader || !item.route) return;
    this.menuItems.forEach(menuItem => (menuItem.active = false));
    item.active = true;
    this.router.navigate([item.route]);
  }

  signOut() {
    this.authService.userSignOut();
  }
}
